import { useCallback } from 'preact/hooks';

import { classNames } from '../utils/UNSAFE_classNames';
import { usePress } from '../hooks/UNSAFE_usePress';
import { useFormFieldContext } from '../hooks/UNSAFE_useFormFieldContext';
import { hide, maxLengthCounterBase, spanStyles } from './MaxLengthCounterStyles.css';

type Props = {
  maxLength: number;
  valueLength?: number;
  onClick?: () => void; // the calling component should focus on the appropriate element when clicked.
};

const noop = () => {};

export function MaxLengthCounter({ maxLength, valueLength = 0, onClick }: Props) {
  const { isFocused } = useFormFieldContext();
  // We don't want mousedown on this component to do anything, so prevent the default behavior.
  const killEvent = useCallback((event: Event) => event.preventDefault(), []);
  const textClasses = classNames([!isFocused && hide]);
  const { pressProps } = usePress(onClick ?? noop);
  return (
    <div class={maxLengthCounterBase} onMouseDown={killEvent} {...pressProps}>
      <span class={textClasses}>
        <span class={spanStyles}>{valueLength}</span>
        <span class={spanStyles}>/</span>
        <span class={spanStyles}>{maxLength}</span>
      </span>
    </div>
  );
}
